
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'ProgressBar',
  props: {
    progress: {
      type: Number,
      default: 0,
    },
    loading: Boolean,
    loadingStatusText: {
      type: String,
      default: '',
    },
    longerThanUsual: Boolean,
    longerThanUsualStatusText: {
      type: String,
      default: '',
    },
  },
});
